var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlay = function SvgPlay(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14 33.213h39.72c1.693 0 2.973-.434 3.84-1.301.867-.868 1.3-2.149 1.3-3.844V5.125c0-1.682-.433-2.956-1.3-3.824C47.833.434 46.553 0 44.86 0H5.14C3.447 0 2.167.434 1.3 1.301.433 2.17 0 3.443 0 5.125v22.943c0 1.695.433 2.976 1.3 3.844.867.867 2.147 1.301 3.84 1.301Zm.06-3.223c-.653 0-1.147-.164-1.48-.49-.333-.327-.5-.818-.5-1.472V5.185c0-.654.167-1.144.5-1.471.333-.327.827-.49 1.48-.49h39.6c.667 0 1.163.163 1.49.49.327.327.49.817.49 1.471v22.843c0 .654-.163 1.145-.49 1.471-.327.327-.823.491-1.49.491H5.2ZM14.94 40h20.12c.44 0 .82-.157 1.14-.47.32-.314.48-.698.48-1.152 0-.44-.16-.82-.48-1.14-.32-.321-.7-.481-1.14-.481H14.94c-.44 0-.82.16-1.14.48-.32.32-.48.7-.48 1.141 0 .454.16.838.48 1.152.32.313.7.47 1.14.47Zm3.58-15.115c0 .547.227.907.68 1.081.453.173.893.14 1.32-.1l13.88-8.188c.413-.254.617-.61.61-1.071-.007-.46-.217-.811-.63-1.051L20.52 7.367a1.487 1.487 0 0 0-1.32-.1c-.453.174-.68.534-.68 1.081v16.537Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;